import { useTranslation } from '@packlink/translation-provider';
import { getContainerStyles, getTitleWrapperStyles } from './EmailTemplateListItemStyles';
import { Typography } from '@shipengine/giger';
import { emailTypesKeys } from '../../constants';

export interface EmailTemplateDisabledItemProps {
    templateKey: emailTypesKeys;
}

export function EmailTemplateDisabledItem({ templateKey }: EmailTemplateDisabledItemProps): JSX.Element {
    const { t } = useTranslation();

    return (
        <div css={getContainerStyles}>
            <section>
                <div css={getTitleWrapperStyles}>
                    <div>
                        <Typography variant="heading5" bold>
                            {t(`branded-emails.template-list.${templateKey}-title`)}
                        </Typography>
                    </div>
                </div>
                <Typography variant="body2">{t(`branded-emails.template-list.${templateKey}-description`)}</Typography>
            </section>
        </div>
    );
}
